import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "7", x2: "21", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "13 6 7 12 13 18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 19V5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowLeftToLine";
const ArrowLeftToLine = memo(themed(Icon));
export {
  ArrowLeftToLine
};
//# sourceMappingURL=arrow-left-to-line.js.map
